import { clsx } from 'clsx';
import { Dispatch, SetStateAction } from 'react';

import {
  RadioButtonChoice,
  RadioButtonsClassNames,
} from '../radioButton.types';

export const RadioButtonRow = ({
  id,
  isRequired,
  adminLabel,
  choice,
  setIsInvalid,
  customId,
}: {
  id: string;
  isRequired: boolean;
  choice: RadioButtonChoice;
  adminLabel: string;
  setIsInvalid: Dispatch<SetStateAction<boolean>>;
  customId: string;
  classNames?: RadioButtonsClassNames;
}) => {
  if (typeof choice === 'string') return null;
  return (
    <div className={`flex gap-2 md:gap-4 cursor-pointer`} key={choice?.text}>
      <div
        className={clsx(
          'checkbox bg-white relative border border-line rounded-full mt-[5px] justify-center items-center'
        )}
      >
        <input
          id={id || customId}
          name={adminLabel || customId}
          type='radio'
          className='opacity-0 absolute peer bottom-0'
          value={choice?.value}
          required={isRequired}
          onInvalid={() => {
            setIsInvalid(true);
          }}
          onInput={() => {
            setIsInvalid(false);
          }}
        />
        <div className='duration-100 h-full w-full opacity-0 peer-checked:opacity-100 pointer-events-none border-4 border-blue-500 rounded-full cursor-pointer' />
      </div>

      {/* eslint-disable-next-line */}
      <label
        htmlFor={id || customId}
        className='cursor-pointer body'
        dangerouslySetInnerHTML={{
          __html: choice?.text ?? '',
        }}
      />
    </div>
  );
};
